import { createCommand } from '@eastcoal/editor/exports'

import { InsertTextVariablePayload } from './interface'

export const INSERT_TEXT_VARIABLE_COMMAND =
  createCommand<InsertTextVariablePayload>('INSERT_TEXT_VARIABLE_COMMAND')
